// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Env from "../../core/Env.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Json from "../../primitives/Json.res.js";
import * as Future from "rescript-future/src/Future.res.js";
import * as Request from "../../core/Request.res.js";
import * as LoadingRoutes from "../../app/Loading/LoadingRoutes.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";

let errorMessage = I18n.t("Wino could not generate the PDF, please reiterate your request.");

let endpoint = Env.pdfUrl() + "/order-document";

function makeRequestBodyJson(orderId) {
  let body = {};
  body["orderId"] = Json.encodeString(orderId);
  return Json.encodeDict(body);
}

function decodeAndMakeUrlExn(json) {
  return new URL(Stdlib_Option.getExn(Json.flatDecodeDictFieldString(Json.decodeDict(json), "url"), undefined));
}

function requestAndOpen(orderId, orderName) {
  let windowName = I18n.template(I18n.t("Download {{orderName}} PDF"), {
    orderName: orderName
  }, undefined);
  let windowUrl = LoadingRoutes.baseRoute(I18n.template(I18n.t("Generating PDF of order {{orderName}}"), {
    orderName: orderName
  }, undefined), undefined);
  let loadingWindow = window.open(windowUrl, windowName);
  if (loadingWindow == null) {
    return Future.value({
      TAG: "Error",
      _0: "OpenWindowError"
    });
  } else {
    return Future.mapError(Future.tap(Request.make(endpoint, "POST", {
      TAG: "JsonBody",
      _0: makeRequestBodyJson(orderId)
    }, undefined, undefined), result => {
      if (result.TAG === "Ok") {
        let generatedPdfUrl = decodeAndMakeUrlExn(result._0);
        loadingWindow.location = generatedPdfUrl.href;
        return;
      }
      loadingWindow.close();
    }), undefined, error => ({
      TAG: "RequestError",
      _0: error
    }));
  }
}

export {
  errorMessage,
  endpoint,
  makeRequestBodyJson,
  decodeAndMakeUrlExn,
  requestAndOpen,
}
/* errorMessage Not a pure module */
